<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Selecione um Plano Semanal </v-card-title>

        <v-select
          :items="disciplinas"
          item-text="descricao"
          item-value="id"
          v-model="disciplinaSelecionada"
          return-object
          label="Selecione uma disciplina"
          solo
        ></v-select>

        <v-select
          :items="$constants.mesesPlanoSemanal"
          item-text="descricao"
          item-value="id"
          v-model="mes"
          return-object
          label="Selecione um mês"
          solo
        ></v-select>
        <v-select
          :items="$constants.semanas"
          item-text="descricao"
          item-value="id"
          v-model="semana"
          return-object
          label="Selecione uma semana"
          solo
        ></v-select>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :dialog="dialog"
            @status="dialog = $event"
            color="blue darken-1"
            text
            @click="cancelar()"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            :disabled="!disciplinaSelecionada || !mes"
            @click="gerarPlanoSemanal(gestaoDeAulasId, mes?.id, semana.id, disciplinaId)"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    gestaoDeAulasId: {
      type: Number,
    },
    disciplinas: {
      type: Array,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
    typeModel: {
      type: String,
    },
  },

  watch: {
    dialog(val) {
      this.$emit("status", val);
    },
    typeModel(val) {
      this.type = val;
    },
  },
  data() {
    return {
      disciplinasArray: this.disciplinas,
      disciplinaSelecionada: null,
      disciplinasDaGestao: [],
      type: null,
      mes: null,
      semana: null,
    };
  },
  methods: {
    async gerarPlanoSemanal(gestaoDeAulasId, mes, semanaId, disciplinaId) {
      try {
        this.$loaderService.open("Gerando plano semanal...");
        const disciplinaId = this.disciplinaSelecionada.id;

        await this.$services.relatoriosService.planoSemanal(
          parseInt(gestaoDeAulasId, 10),
          parseInt(mes, 10),
          parseInt(semanaId, 10),
          parseInt(disciplinaId, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    cancelar() {
      this.disciplinaSelecionada = null;
      this.mes = null;
      this.$emit("status", false);
    },
  },
};
</script>
